(() => {
  const root = document.querySelector('[data-gw]'); if (!root) return;
  const split = root.querySelector('.split');
  const canvas = document.querySelector('.fw-canvas');
  const ctx = canvas.getContext('2d');
  const qLayer = document.querySelector('.quotes');
  const gn = document.querySelector('.half--gn');
  const jd = document.querySelector('.half--jd');
  const seam = document.querySelector('.seam');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let data = []; try { data = JSON.parse(root.querySelector('[data-gw-reviews]').textContent); } catch (e) {}
  const reviews = data.filter(r => r && r.q).sort(() => Math.random() - .5);
  let ri = 0, W = 0, H = 0, dpr = 1;

  const PAL = {
    gn: ['#A8864B', '#d9b874', '#e02630', '#a0161f', '#F3EDE0'],
    jd: ['#111111', '#111111', '#3a3a3a', '#B8B8B4', '#ffffff']
  };

  function size() {
    const r = split.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    canvas.width = W * dpr; canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (innerWidth < 900) { seam.style.top = gn.offsetHeight + 'px'; }
    else { seam.style.top = ''; }
  }
  addEventListener('resize', size); size();

  // Rect of a half relative to the split
  function rectOf(side) {
    const s = split.getBoundingClientRect();
    const r = (side === 'gn' ? gn : jd).getBoundingClientRect();
    return { x: r.left - s.left, y: r.top - s.top, w: r.width, h: r.height };
  }

  // "Quiet zones" — where the main copy lives; quotes avoid them
  // Bursts land over each half's picture zone (arch photo / bottle wall),
  // never over the headline, copy or door button.
  function burstPoint(side) {
    const r = rectOf(side);
    const s = split.getBoundingClientRect();
    const m = document.querySelector(side === 'gn' ? '.gn-arch' : '.jd-wall').getBoundingClientRect();
    const cx = m.left - s.left + m.width / 2, top = m.top - s.top, h = m.height;
    const spread = Math.min(r.w * 0.16, 120);
    if (innerWidth < 600) {
      // phones: quotes use the open band above (GNCC) or below (JD) the door content
      const inner = (side === 'gn' ? gn : jd).querySelector('.half__inner').getBoundingClientRect();
      const zone = side === 'gn'
        ? { top: r.y + 64, bottom: inner.top - s.top - 6 }
        : { top: inner.bottom - s.top + 22, bottom: r.y + r.h - 6 };
      return { x: r.x + r.w / 2 + (Math.random() * 2 - 1) * 30, y: (zone.top + zone.bottom) / 2, side, r, zone, short: true };
    }
    return { x: cx + (Math.random() * 2 - 1) * spread, y: top + h * (0.25 + Math.random() * 0.4), side, r, zone: { top: top - 40, bottom: top + h + 10 } };
  }

  // ---------- particles ----------
  const rockets = [], sparks = [];
  function launch(side, onBurst) {
    const p = burstPoint(side);
    const startX = p.x + (Math.random() - .5) * 60;
    const startY = p.r.y + p.r.h + 10;
    if (reduce) { onBurst && onBurst(p); return; }
    rockets.push({ x: startX, y: startY, tx: p.x, ty: p.y, t: 0, dur: 52 + Math.random() * 14, side, p, onBurst, trail: [] });
  }
  function burst(x, y, side) {
    const cols = PAL[side];
    const n = side === 'jd' ? 64 : 84;
    for (let i = 0; i < n; i++) {
      const a = (Math.PI * 2 * i) / n + Math.random() * .2;
      const sp = (side === 'jd' ? 2.2 : 2.6) + Math.random() * 3.2;
      sparks.push({ x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, decay: .010 + Math.random() * .012,
        c: cols[Math.floor(Math.random() * cols.length)], side, s: side === 'jd' ? 2 + Math.random() * 3 : 1.2 + Math.random() * 1.8 });
    }
    // ring of glitter for GNCC, spray splatter for JD
    if (side === 'gn') for (let i = 0; i < 26; i++) {
      const a = Math.random() * Math.PI * 2, sp = Math.random() * 1.4;
      sparks.push({ x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, decay: .006 + Math.random() * .006, c: '#f3d9a8', side, s: 1, tw: true });
    }
  }
  function frame() {
    ctx.clearRect(0, 0, W, H);
    for (let i = rockets.length - 1; i >= 0; i--) {
      const r = rockets[i]; r.t++;
      const k = r.t / r.dur, e = 1 - Math.pow(1 - k, 3);
      const x = r.x + (r.tx - r.x) * e, y = r.y + (r.ty - r.y) * e;
      r.trail.push([x, y]); if (r.trail.length > 14) r.trail.shift();
      ctx.lineCap = 'round';
      for (let j = 1; j < r.trail.length; j++) {
        ctx.strokeStyle = r.side === 'gn' ? `rgba(168,134,75,${j / r.trail.length})` : `rgba(17,17,17,${j / r.trail.length * .8})`;
        ctx.lineWidth = r.side === 'gn' ? 2 : 3;
        ctx.beginPath(); ctx.moveTo(r.trail[j - 1][0], r.trail[j - 1][1]); ctx.lineTo(r.trail[j][0], r.trail[j][1]); ctx.stroke();
      }
      if (k >= 1) { burst(r.tx, r.ty, r.side); r.onBurst && r.onBurst(r.p); rockets.splice(i, 1); }
    }
    for (let i = sparks.length - 1; i >= 0; i--) {
      const s = sparks[i];
      s.vx *= .975; s.vy = s.vy * .975 + .045; s.x += s.vx; s.y += s.vy; s.life -= s.decay;
      if (s.life <= 0) { sparks.splice(i, 1); continue; }
      let a = Math.max(0, s.life);
      if (s.tw) a *= .5 + .5 * Math.sin(s.life * 60);
      ctx.globalAlpha = a; ctx.fillStyle = s.c;
      if (s.side === 'jd') ctx.fillRect(s.x, s.y, s.s, s.s);
      else { ctx.beginPath(); ctx.arc(s.x, s.y, s.s, 0, Math.PI * 2); ctx.fill(); }
    }
    ctx.globalAlpha = 1;
    requestAnimationFrame(frame);
  }
  if (!reduce) requestAnimationFrame(frame);

  // ---------- quotes ----------
  let live = 0;
  function showQuote(p) {
    if (!reviews.length || live >= 2) return;
    let rv = reviews[ri++ % reviews.length];
    if (p.short) { let k = 0; while (rv.q.length > 60 && k++ < reviews.length) rv = reviews[ri++ % reviews.length]; }
    const el = document.createElement('figure');
    el.className = 'q q--' + p.side;
    el.innerHTML = `<div class="stars">${p.side === 'jd' ? '★★★★★ FAN MAIL' : '★★★★★'}</div><blockquote>“${rv.q}”</blockquote><figcaption>${rv.n} · on ${rv.p}</figcaption>`;
    qLayer.appendChild(el);
    // clamp inside its half
    const w = el.offsetWidth, h = el.offsetHeight, r = p.r, pad = 18;
    const x = Math.min(Math.max(p.x, r.x + w / 2 + pad), r.x + r.w - w / 2 - pad);
    const z = p.zone;
    const y = Math.min(Math.max(p.y, z.top + h / 2), z.bottom - h / 2);
    el.style.left = x + 'px'; el.style.top = y + 'px';
    live++;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('on')));
    setTimeout(() => { el.classList.remove('on'); el.classList.add('off'); }, 3800);
    setTimeout(() => { el.remove(); live--; }, 5000);
  }

  // Alternate halves; only while the split is on screen and tab visible
  let side = Math.random() < .5 ? 'gn' : 'jd', visible = true, timer;
  new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: .25 }).observe(split);
  function tick() {
    if (visible && !document.hidden) { launch(side, showQuote); side = side === 'gn' ? 'jd' : 'gn'; }
    timer = setTimeout(tick, 2900 + Math.random() * 900);
  }
  setTimeout(tick, 900);

  // A bonus burst when someone leans toward a door (desktop)
  let lastHover = 0;
  [gn, jd].forEach(h => h.addEventListener('mouseenter', () => {
    const now = Date.now(); if (now - lastHover < 2500) return; lastHover = now;
    launch(h.dataset.side, null);
  }));

  // ---------- email form: add interest tags before Shopify submits ----------
  const ef = root.querySelector('#gw-email-form');
  if (ef) ef.addEventListener('submit', () => {
    const hidden = ef.querySelector('input[name="contact[tags]"]'); if (!hidden) return;
    const tags = ['newsletter', 'welcome-page'];
    ef.querySelectorAll('input[data-tag]:checked').forEach(c => tags.push(c.dataset.tag));
    hidden.value = tags.join(',');
  });
  // after a successful signup Shopify reloads the page; bring the card into view
  if (/customer_posted=true/.test(location.search)) {
    const done = root.querySelector('.offer--email .offer__done');
    if (done) setTimeout(() => { done.scrollIntoView({ block: 'center' }); launch('gn', null); }, 300);
  }
  root.querySelectorAll('.code').forEach(b => b.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(b.dataset.code); } catch (e) {}
    const s = b.querySelector('small'); const t = s.textContent; s.textContent = 'copied'; setTimeout(() => s.textContent = t, 1600);
  }));
})();
